import { useMsal } from '@azure/msal-react';
import {
  AppBar,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { AccountCircle } from '@material-ui/icons';
import React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import packageJson from '../../../package.json';

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  loggedInUser: {
    color: theme.palette.common.white,
  },
}));

const NavigationBar = () => {
  const classes = useStyles();
  const { userName } = useSelector((state) => ({ userName: state.user.fullName }));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  // const { logout } = useMsal();
  const { instance } = useMsal();
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const processLogout = () => {
    localStorage.clear();
    instance.logout();
  };
  return (
    <AppBar position="fixed">
      <Toolbar>
        <Typography variant="h6" className={classes.title} title={"v." + packageJson.version}>
          POST 2.0
        </Typography>
        <IconButton
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          className={classes.loggedInUser}
        >
          <AccountCircle /> {userName}
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={open}
          onClose={handleClose}
        >
          <MenuItem onClick={processLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};
export default NavigationBar;
